import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Buffer } from 'buffer'
import '@/styles/globals.css'
import '@/stores/themeStore' // initialise theme before first render (prevents flash)
import App from './App.tsx'

// Polyfill Buffer for @solana/web3.js in the browser
;(globalThis as Record<string, unknown>).Buffer = Buffer

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
